
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_12i0j_1cjfm_13",
  "with-expanded-motion": "awsui_with-expanded-motion_12i0j_1cjfm_27",
  "legacy": "awsui_legacy_12i0j_1cjfm_41",
  "ai-drawer": "awsui_ai-drawer_12i0j_1cjfm_41",
  "bottom-drawer": "awsui_bottom-drawer_12i0j_1cjfm_41",
  "last-opened": "awsui_last-opened_12i0j_1cjfm_49",
  "drawer-global": "awsui_drawer-global_12i0j_1cjfm_53",
  "drawer-expanded": "awsui_drawer-expanded_12i0j_1cjfm_62",
  "drawer-hidden": "awsui_drawer-hidden_12i0j_1cjfm_66",
  "has-next-siblings": "awsui_has-next-siblings_12i0j_1cjfm_76",
  "global-drawer-wrapper": "awsui_global-drawer-wrapper_12i0j_1cjfm_76",
  "drawer-content-container": "awsui_drawer-content-container_12i0j_1cjfm_90",
  "drawer-gap": "awsui_drawer-gap_12i0j_1cjfm_93",
  "drawer-close-button": "awsui_drawer-close-button_12i0j_1cjfm_111",
  "drawer-expanded-mode-button": "awsui_drawer-expanded-mode-button_12i0j_1cjfm_117",
  "drawer-content": "awsui_drawer-content_12i0j_1cjfm_90",
  "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_1cjfm_129",
  "drawer-slider": "awsui_drawer-slider_12i0j_1cjfm_132",
  "drawer-actions": "awsui_drawer-actions_12i0j_1cjfm_184",
  "ai-drawer-slider-handle": "awsui_ai-drawer-slider-handle_12i0j_1cjfm_241",
  "drawer-content-header": "awsui_drawer-content-header_12i0j_1cjfm_266",
  "drawer-content-header-content": "awsui_drawer-content-header-content_12i0j_1cjfm_282",
  "drawer-back-to-console-slot": "awsui_drawer-back-to-console-slot_12i0j_1cjfm_302",
  "drawer-back-to-console-button-wrapper": "awsui_drawer-back-to-console-button-wrapper_12i0j_1cjfm_341",
  "drawer-back-to-console-button": "awsui_drawer-back-to-console-button_12i0j_1cjfm_341",
  "drawer-back-to-console-custom-button": "awsui_drawer-back-to-console-custom-button_12i0j_1cjfm_414",
  "drawer-content-content": "awsui_drawer-content-content_12i0j_1cjfm_420",
  "bottom-drawer-content-header": "awsui_bottom-drawer-content-header_12i0j_1cjfm_481",
  "bottom-drawer-content-header-content": "awsui_bottom-drawer-content-header-content_12i0j_1cjfm_488",
  "bottom-drawer-actions": "awsui_bottom-drawer-actions_12i0j_1cjfm_496",
  "runtime-feature-notifications-drawer-content": "awsui_runtime-feature-notifications-drawer-content_12i0j_1cjfm_504",
  "runtime-feature-notifications-footer": "awsui_runtime-feature-notifications-footer_12i0j_1cjfm_508"
};
  